<div class="flex h-full w-full flex-col items-center justify-center [&_h2]:my-1.5">
  <app-card>
    <app-card-header>
      <h2>Ошибка 404!</h2>
    </app-card-header>
    <app-card-body>

      <div class="mb-10 text-center">
        <p>Страница не найдена, или файл, или документ, или что-то ещё, смотря что Вы искали или пытались
          посмотреть!</p>

        <p class="m-0 text-[2rem]">😿</p>

        <p>Жаль, но теперь наш админ получит по шляпе) и может начнёт лучше работать.</p>

        <p>А Вам пока предлагаем перейти на... на например</p>
      </div>


      <div class="flex flex-wrap justify-between gap-5 [&>div]:flex [&>div]:flex-1 [&>div]:flex-col [&>div]:items-center [&>div>p:first-child]:h-[50px] [&>div>p:first-child]:text-center">

        <div>
          <p>а вот на главную страницу сайта например</p>
          <a hlmBtn routerLink="/">на главную</a>
          <p class="text-[11px] text-[var(--primary-color-lighter)]">*хороший выбор</p>

        </div>
        <span class="border border-[var(--bg-color-darker)]"></span>
        <div>
          <p>или попробовать вернуться - в прошлое</p>
          <a hlmBtn variant="destructive" (click)="back()">в прошлое</a>
          <p class="text-[11px] text-[var(--danger-bg-color)]">*но это может быть опасно</p>

        </div>
      </div>
    </app-card-body>
    <app-card-footer>
      <p class="my-[50px] text-center">Мы не прощаемся, хорошего дня!</p>
    </app-card-footer>
  </app-card>


</div>
